import React, { useEffect, useState } from "react";
import "./challenge.css";

import api from "../../../api";
import { PlanCard } from "./planCard";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Loader } from "../loader";

export const ChallengePlan = () => {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [selectedData, setSelectedData] = useState({});

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = (item) => {
    setSelectedData(item);
    setShowEdit(true);
  };

  const getPosts = async () => {
    try {
      setLoader(true);
      const cData = await api.getChalengePlanAdmin();
      console.log(cData);
      if (cData?.success) {
        setData(cData.challenges);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const deletePost = async (id) => {
    try {
      setLoader(true);
      const isConfirmed = window.confirm(
        "Are you sure you want to delete this item?"
      );
      if (isConfirmed) {
        const resp = await api.deleteChallengePlan({ challengeId: id });
        console.log("deleted");
        getPosts();
      }

      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getPosts();
  }, []);

  return (
    <div className="container-fluid payHistoryPage">
      <div className="row mx-0 drivers-row">
        <div className="col-sm-6 d-flex justify-content-between pr-0 flex-wrap my-2">
          <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
            Challenge Plan
          </h4>
        </div>
        <div className="col-sm-6 d-flex justify-content-end mb-3">
          <button className="themeBtn" onClick={handleShow}>
            Create Challenge Plan
          </button>
        </div>
      </div>
      <div className="row">
        {data?.map((plan, key) => (
          <div className="col-md-6" key={key}>
            <PlanCard
              plan={plan}
              deletePost={deletePost}
              handleShow={handleShowEdit}
              admin={true}
            />
          </div>
        ))}
      </div>

      <Modal show={show} size="lg" onHide={handleClose} centered className="">
        <Modal.Body>
          <div className="otpModalMain">
            <div className="closeIcon" onClick={handleClose}>
              <i className="fa-solid fa-xmark" />
            </div>
            <CreateChallenge getPosts={getPosts} setShow={setShow} />
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showEdit}
        size="lg"
        onHide={handleCloseEdit}
        centered
        className=""
      >
        <Modal.Body>
          <div className="otpModalMain">
            <div className="closeIcon" onClick={handleCloseEdit}>
              <i className="fa-solid fa-xmark" />
            </div>
            <EditChallenge
              getPosts={getPosts}
              setShow={setShowEdit}
              selectedData={selectedData}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export function CreateChallenge({ getPosts, setShow }) {
  const adminStore = useSelector((state) => state.adminReducer);

  const [loader, setLoader] = useState(false);
  const [inputData, setInputData] = useState({});
  const [features, setFeatures] = useState([""]); // start with one empty input

  const validate = () => {
    if (!inputData?.planType) {
      return "Please Enter Plan Type";
    }
    if (!inputData?.name) {
      return "Please Enter Name";
    }
    if (!inputData?.level) {
      return "Please Enter Level";
    }
    if (!inputData?.accountBalance) {
      return "Please Enter Account Balance";
    }
    if (!inputData?.winReward) {
      return "Please Enter Win Reward";
    }
    if (features.length == 0) {
      return "Please add atleast 1 feature";
    }
    if (!inputData?.days) {
      return "Please Enter Days";
    }
    if (!inputData?.hours) {
      return "Please Enter Hours";
    }
    if (!inputData?.minutes) {
      return "Please Enter Minutes";
    }
    if (!inputData?.seconds) {
      return "Please Enter Seconds";
    }

    return false;
  };

  const handleSubmit = async () => {
    try {
      console.log(inputData);

      let validator = validate();
      if (validator) {
        alert(validator);
        return;
      }
      setLoader(true);
      const cleaned = features.map((f) => f.trim()).filter((f) => f !== ""); // remove empty values

      let payload = {
        planType: inputData?.planType,
        name: inputData?.name,
        level: inputData?.level,
        accountBalance: inputData?.accountBalance,
        target: inputData?.target,
        winReward: inputData?.winReward,
        features: cleaned,
        isLive: inputData?.isLive,
        duration: {
          days: inputData?.days,
          hours: inputData?.hours,
          minutes: inputData?.minutes,
          seconds: inputData?.seconds,
        },
      };
      console.log(payload);
      const response = await api.createChallengePlan(payload);
      if (response?.success) {
        alert("Plan added successfully.");
        setInputData({
          email: "",
          description: "",
        });
        setLoader(false);

        getPosts();
        setShow(false);
      } else {
        setLoader(false);
        alert("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      console.log(error?.message);
      console.log(error);
      alert(error?.message || "Something went wrong");
    }
  };

  const addFeature = () => {
    setFeatures([...features, ""]);
  };

  const handleChange = (index, value) => {
    const updated = [...features];
    updated[index] = value;
    setFeatures(updated);
  };

  const removeFeature = (index) => {
    const updated = features.filter((_, i) => i !== index);
    setFeatures(updated);
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-xl-6 col-md-7  d-flex justify-content-between pr-0">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  Create Challenge
                </h4>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group my-3">
                  <label>Plan Type</label>
                  <input
                    type="text"
                    name="planType"
                    value={inputData?.planType}
                    className="form-control"
                    placeholder="Plan Type"
                    onChange={(e) =>
                      setInputData({ ...inputData, planType: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group my-3">
                  <label>Name</label>

                  <input
                    type="text"
                    name="name"
                    value={inputData?.name}
                    className="form-control"
                    placeholder="Name"
                    onChange={(e) =>
                      setInputData({ ...inputData, name: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group my-3">
                  <label>Level</label>

                  <input
                    type="text"
                    name="level"
                    value={inputData?.level}
                    className="form-control"
                    placeholder="Level"
                    onChange={(e) =>
                      setInputData({ ...inputData, level: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group my-3">
                  <label>Account Balance</label>

                  <input
                    type="number"
                    name="accountBalance"
                    value={inputData?.accountBalance}
                    className="form-control"
                    placeholder="Account Balance"
                    onChange={(e) =>
                      setInputData({
                        ...inputData,
                        accountBalance: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group my-3">
                  <label>Target</label>

                  <input
                    type="number"
                    name="target"
                    value={inputData?.target}
                    className="form-control"
                    placeholder="Target"
                    onChange={(e) =>
                      setInputData({ ...inputData, target: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group my-3">
                  <label>Win Reward</label>

                  <input
                    type="number"
                    name="winReward"
                    value={inputData?.winReward}
                    className="form-control"
                    placeholder="Win Reward"
                    onChange={(e) =>
                      setInputData({ ...inputData, winReward: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group my-3">
                  <label>Days</label>

                  <input
                    type="number"
                    name="days"
                    value={inputData?.days}
                    className="form-control"
                    placeholder="Days"
                    onChange={(e) =>
                      setInputData({ ...inputData, days: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group my-3">
                  <label>Hours</label>

                  <input
                    type="number"
                    name="hours"
                    value={inputData?.hours}
                    className="form-control"
                    placeholder="Hours"
                    onChange={(e) =>
                      setInputData({ ...inputData, hours: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group my-3">
                  <label>Minutes</label>

                  <input
                    type="number"
                    name="minutes"
                    value={inputData?.minutes}
                    className="form-control"
                    placeholder="Minutes"
                    onChange={(e) =>
                      setInputData({ ...inputData, minutes: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group my-3">
                  <label>Seconds</label>

                  <input
                    type="number"
                    name="seconds"
                    value={inputData?.seconds}
                    className="form-control"
                    placeholder="Seconds"
                    onChange={(e) =>
                      setInputData({ ...inputData, seconds: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-12">
                {features.map((feature, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", gap: 10, marginBottom: 10 }}
                  >
                    <input
                      type="text"
                      placeholder={`Feature ${index + 1}`}
                      value={feature}
                      onChange={(e) => handleChange(index, e.target.value)}
                      className="form-control"
                    />

                    <button
                      onClick={() => removeFeature(index)}
                      style={{
                        padding: "6px 12px",
                        background: "red",
                        color: "#fff",
                        borderRadius: 10,
                      }}
                    >
                      X
                    </button>
                  </div>
                ))}

                <button
                  onClick={addFeature}
                  style={{ padding: "8px 16px", marginRight: 10 }}
                >
                  + Add Feature
                </button>
              </div>
              <div className="col-12">
                <div className="form-group my-3">
                  <input
                    type="checkbox"
                    name="isLive"
                    value={inputData?.isLive}
                    className="me-2"
                    placeholder="Is live"
                    onChange={(e) =>
                      setInputData({ ...inputData, isLive: e.target.checked })
                    }
                  />
                  <label>Live Challenge</label>
                </div>
              </div>
            </div>

            <div className="sendMailBtn mt-3">
              <button onClick={handleSubmit} className="btn-dark">
                Submit
              </button>
            </div>

            {/* table */}
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
    </>
  );
}

export function EditChallenge({ getPosts, setShow, selectedData }) {
  const adminStore = useSelector((state) => state.adminReducer);

  const [loader, setLoader] = useState(false);
  const [inputData, setInputData] = useState({});
  const [features, setFeatures] = useState([""]); // start with one empty input

  const validate = () => {
    if (!inputData?.planType) {
      return "Please Enter Plan Type";
    }
    if (!inputData?.name) {
      return "Please Enter Name";
    }
    if (!inputData?.level) {
      return "Please Enter Level";
    }
    if (!inputData?.accountBalance) {
      return "Please Enter Account Balance";
    }
    if (!inputData?.winReward) {
      return "Please Enter Win Reward";
    }
    if (features.length == 0) {
      return "Please add atleast 1 feature";
    }
    if (
      inputData?.days == 0 &&
      inputData?.hours == 0 &&
      inputData?.minutes == 0 &&
      inputData?.seconds == 0
    ) {
      return "Please Enter Days";
    }
    return false;
  };

  const handleSubmit = async () => {
    try {
      console.log(inputData);

      let validator = validate();
      if (validator) {
        alert(validator);
        return;
      }
      setLoader(true);
      const cleaned = features.map((f) => f.trim()).filter((f) => f !== ""); // remove empty values

      let payload = {
        challengeId: inputData?._id,
        planType: inputData?.planType,
        name: inputData?.name,
        level: inputData?.level,
        accountBalance: inputData?.accountBalance,
        target: inputData?.target,
        winReward: inputData?.winReward,
        features: cleaned,
        isLive: inputData?.isLive,
        duration: {
          days: inputData?.days,
          hours: inputData?.hours,
          minutes: inputData?.minutes,
          seconds: inputData?.seconds,
        },
      };
      console.log(payload);
      const response = await api.editChallengePlan(payload);
      if (response?.success) {
        alert("Plan updated successfully.");
        setInputData({
          email: "",
          description: "",
        });
        setLoader(false);

        getPosts();
        setShow(false);
      } else {
        setLoader(false);
        alert("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      console.log(error?.message);
      console.log(error);
      alert(error?.message || "Something went wrong");
    }
  };

  const addFeature = () => {
    setFeatures([...features, ""]);
  };

  const handleChange = (index, value) => {
    const updated = [...features];
    updated[index] = value;
    setFeatures(updated);
  };

  const removeFeature = (index) => {
    const updated = features.filter((_, i) => i !== index);
    setFeatures(updated);
  };

  useEffect(() => {
    let paylaod = {
      planType: selectedData.planType,
      name: selectedData.name,
      level: selectedData.level,
      accountBalance: selectedData.accountBalance,
      target: selectedData.target,
      winReward: selectedData.winReward,
      features: selectedData.features,
      isLive: selectedData.isLive,
      days: selectedData.duration.days,
      hours: selectedData.duration.hours,
      minutes: selectedData.duration.minutes,
      seconds: selectedData.duration.seconds,
      _id: selectedData._id,
    };
    setInputData(paylaod);
    setFeatures(selectedData?.features);
  }, []);

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-xl-6 col-md-7  d-flex justify-content-between pr-0">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  Create Challenge
                </h4>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group my-3">
                  <label>Plan Type</label>
                  <input
                    type="text"
                    name="planType"
                    value={inputData?.planType}
                    className="form-control"
                    placeholder="Plan Type"
                    onChange={(e) =>
                      setInputData({ ...inputData, planType: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group my-3">
                  <label>Name</label>

                  <input
                    type="text"
                    name="name"
                    value={inputData?.name}
                    className="form-control"
                    placeholder="Name"
                    onChange={(e) =>
                      setInputData({ ...inputData, name: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group my-3">
                  <label>Level</label>

                  <input
                    type="text"
                    name="level"
                    value={inputData?.level}
                    className="form-control"
                    placeholder="Level"
                    onChange={(e) =>
                      setInputData({ ...inputData, level: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group my-3">
                  <label>Account Balance</label>

                  <input
                    type="number"
                    name="accountBalance"
                    value={inputData?.accountBalance}
                    className="form-control"
                    placeholder="Account Balance"
                    onChange={(e) =>
                      setInputData({
                        ...inputData,
                        accountBalance: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group my-3">
                  <label>Target</label>

                  <input
                    type="number"
                    name="target"
                    value={inputData?.target}
                    className="form-control"
                    placeholder="Target"
                    onChange={(e) =>
                      setInputData({ ...inputData, target: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group my-3">
                  <label>Win Reward</label>

                  <input
                    type="number"
                    name="winReward"
                    value={inputData?.winReward}
                    className="form-control"
                    placeholder="Win Reward"
                    onChange={(e) =>
                      setInputData({ ...inputData, winReward: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group my-3">
                  <label>Days</label>

                  <input
                    type="number"
                    name="days"
                    value={inputData?.days}
                    className="form-control"
                    placeholder="Days"
                    onChange={(e) =>
                      setInputData({ ...inputData, days: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group my-3">
                  <label>Hours</label>

                  <input
                    type="number"
                    name="hours"
                    value={inputData?.hours}
                    className="form-control"
                    placeholder="Hours"
                    onChange={(e) =>
                      setInputData({ ...inputData, hours: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group my-3">
                  <label>Minutes</label>

                  <input
                    type="number"
                    name="minutes"
                    value={inputData?.minutes}
                    className="form-control"
                    placeholder="Minutes"
                    onChange={(e) =>
                      setInputData({ ...inputData, minutes: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group my-3">
                  <label>Seconds</label>

                  <input
                    type="number"
                    name="seconds"
                    value={inputData?.seconds}
                    className="form-control"
                    placeholder="Seconds"
                    onChange={(e) =>
                      setInputData({ ...inputData, seconds: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-12">
                {features.map((feature, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", gap: 10, marginBottom: 10 }}
                  >
                    <input
                      type="text"
                      placeholder={`Feature ${index + 1}`}
                      value={feature}
                      onChange={(e) => handleChange(index, e.target.value)}
                      className="form-control"
                    />

                    <button
                      onClick={() => removeFeature(index)}
                      style={{
                        padding: "6px 12px",
                        background: "red",
                        color: "#fff",
                        borderRadius: 10,
                      }}
                    >
                      X
                    </button>
                  </div>
                ))}

                <button
                  onClick={addFeature}
                  style={{ padding: "8px 16px", marginRight: 10 }}
                >
                  + Add Feature
                </button>
              </div>
              <div className="col-12">
                <div className="form-group my-3">
                  <input
                    type="checkbox"
                    name="isLive"
                    value={inputData?.isLive}
                    checked={inputData?.isLive}
                    className="me-2"
                    placeholder="Is live"
                    onChange={(e) =>
                      setInputData({ ...inputData, isLive: e.target.checked })
                    }
                  />
                  <label>Live Challenge</label>
                </div>
              </div>
            </div>

            <div className="sendMailBtn mt-3">
              <button onClick={handleSubmit} className="btn-dark">
                Submit
              </button>
            </div>

            {/* table */}
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
    </>
  );
}
